/**
 * badge-i18n.ts — i18n badges (18/06/2026)
 *
 * Helpers uniques pour résoudre le nom et la description d'un badge selon la
 * langue active. Évite de répéter la cascade nameFr/En/legacy dans chaque
 * composant. Calqué sur offer-i18n.ts (Lot 8).
 *
 * Cascade :
 *   - language === "fr" → champFr || champEn || champ legacy || ""
 *   - autre (en, ...)    → champEn || champFr || champ legacy || ""
 *
 * Les champs legacy `name`/`description` sont conservés en dernier recours pour
 * les badges pas encore migrés / pas encore retraduits par le cron.
 */

type BadgeI18nFields = {
  name?: string | null;
  description?: string | null;
  nameFr?: string | null;
  nameEn?: string | null;
  descriptionFr?: string | null;
  descriptionEn?: string | null;
};

export function pickBadgeName(
  badge: BadgeI18nFields | null | undefined,
  language: string | undefined,
): string {
  if (!badge) return "";
  const isFr = (language || "fr").toLowerCase().startsWith("fr");
  if (isFr) {
    return badge.nameFr || badge.nameEn || badge.name || "";
  }
  return badge.nameEn || badge.nameFr || badge.name || "";
}

export function pickBadgeDescription(
  badge: BadgeI18nFields | null | undefined,
  language: string | undefined,
): string {
  if (!badge) return "";
  const isFr = (language || "fr").toLowerCase().startsWith("fr");
  if (isFr) {
    return badge.descriptionFr || badge.descriptionEn || badge.description || "";
  }
  return badge.descriptionEn || badge.descriptionFr || badge.description || "";
}
